import React from 'react';
import { PageHero, Section } from '../components/UI';
import styles from './Terms.module.css';

const SECTIONS = [
  {
    title: 'Information We Collect',
    body: [
      'When you contact us, register for an IT training program, submit an enquiry, or otherwise interact with our website, we may collect information such as your name, email address, telephone number, educational or professional information, course preferences, and other information that you voluntarily provide.',
      'We may also collect certain technical information when you visit our website, including your IP address, browser type, device information, pages visited, and general website usage information.',
    ],
  },
  {
    title: 'How We Use Your Information',
    body: [
      'We use the information we collect to process training registrations, communicate with students and prospective students, provide information about our courses, schedule training sessions, provide course-related updates and support, process payments, issue certificates where applicable, improve our training programs and website, and comply with applicable legal requirements.',
      'We may also use your contact information to send you information about relevant courses, schedules, offers, or other training-related communications. You may request that we stop sending promotional communications at any time.',
    ],
  },
  {
    title: 'Payment Information',
    body: [
      'Payments for our training programs may be processed through third-party payment gateways or financial institutions. Metawave Solutions may receive transaction-related information necessary to confirm and manage your payment. We do not intend to store complete credit/debit card details on our website.',
    ],
  },
  {
    title: 'Sharing of Information',
    body: [
      'We may share personal information with trusted third-party service providers when necessary to operate our training programs, process payments, provide technology services, communicate with students, or maintain our website.',
      'We may also disclose information when required by applicable law, legal process, or governmental authority.',
      'We do not sell or rent your personal information to third parties for their independent marketing purposes.',
    ],
  },
  {
    title: 'Data Security',
    body: [
      'We take reasonable measures to protect personal information against unauthorized access, misuse, loss, alteration, or disclosure. However, no electronic transmission or storage system can be guaranteed to be completely secure.',
    ],
  },
  {
    title: 'Cookies',
    body: [
      'Our website may use cookies and similar technologies to improve website functionality, understand website usage, and enhance the user experience. You may manage or disable cookies through your browser settings.',
    ],
  },
  {
    title: 'Course and Training Information',
    body: [
      'Information provided by students during registration or training may be used for administering the training program, maintaining attendance or enrollment records, providing course support, and issuing certificates or other course-related documentation where applicable.',
    ],
  },
  {
    title: 'Third-Party Websites',
    body: [
      'Our website may contain links to third-party websites or services. Metawave Solutions is not responsible for the privacy practices or content of third-party websites. Users are encouraged to review the privacy policies of those websites before providing personal information.',
    ],
  },
  {
    title: 'Policy Updates',
    body: [
      'Metawave Solutions may update this Privacy Policy from time to time. Any changes will be published on this page along with the updated effective date.',
    ],
  },
];

export default function Privacy() {
  return (
    <>
      <PageHero
        tag="Legal"
        title="Privacy Policy"
        subtitle="How we collect, use, store, and protect your personal information."
      />

      <Section variant="paper">
        <div className={styles.container}>
          <p className={styles.intro}>
            Metawave Solutions respects the privacy of our students,
            trainees, website visitors, and users. This Privacy Policy
            explains how we collect, use, store, and protect personal
            information when you visit our website,
            www.metawavesolutions.com, register for our IT training
            programs, contact us, or use our training-related services.
          </p>

          {SECTIONS.map((s, i) => (
            <div key={i} className={styles.block}>
              <h3 className={styles.blockTitle}>{s.title}</h3>
              {s.body.map((p, j) => (
                <p key={j} className={styles.bodyText}>
                  {p}
                </p>
              ))}
            </div>
          ))}

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>Contact Us</h3>
            <p className={styles.bodyText}>
              If you have questions regarding this Privacy Policy or how
              your information is handled, please contact us through the
              contact details provided on our website.
            </p>
            <p className={styles.bodyText}>
              Website:{' '}
              <a href="https://www.metawavesolutions.com">
                www.metawavesolutions.com
              </a>
              <br />
              Email: <a href="mailto:jobs@metawavesolutions.com">jobs@metawavesolutions.com</a>
            </p>
          </div>
        </div>
      </Section>
    </>
  );
}
